import { useQuery } from "@tanstack/react-query";
import { axios } from "../../../shared/lib/axios";

export const getCourse = async (courseId) => {
  const res = await axios.apiCadernoVirtual(
    "/catalog-service/shelf/getByCourseId",
    {
      params: { courseId },
    }
  );

  return res.object;
};

export const useCourse = ({ config, courseId } = {}) => {
  return useQuery({
    ...config,
    queryKey: ["course", { courseId }],
    queryFn: () => getCourse(courseId),
  });
};
